var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_498_8696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8778 59.4824H2.70801V21.5195H78.5005V34.0472C78.5005 34.0472 69.6703 34.4269 69.6703 41.2602C69.6703 48.0935 78.5005 48.0935 78.5005 48.0935V59.4824H47.5948",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.6318,
    y1: 23.5176,
    x2: 60.6318,
    y2: 57.4805,
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeDasharray: "4 8"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_498_8696",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 20,
    width: 19.1321,
    height: 41,
    rx: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 20,
    width: 19.1321,
    height: 41,
    rx: 2,
    fill: "#B31B34",
    stroke: "black",
    strokeWidth: 8,
    strokeLinejoin: "round",
    mask: "url(#path-3-inside-1_498_8696)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_498_8696"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.8708c3067f4db0cbeb7e12d7a37df9fe.svg";
export { ForwardRef as ReactComponent };